import BodyCopyComponent from './component.jsx'
export default BodyCopyComponent
